import React from 'react';
// components
import { Button } from '../Button';
import { Icons } from '../Icons';
export const FilterRow = ({ filters, clearFilters, clearDisabled, languageData, }) => {
    const crossIcon = React.createElement(Icons, { iconName: "ic-ui-cancel-sm" });
    return (React.createElement("div", { className: "filter-row-container" },
        React.createElement("div", { className: "filter-row-filters" }, filters),
        React.createElement("div", { className: "filter-row-clear" },
            React.createElement(Button, { disabled: clearDisabled, style: "subtle", leftIcon: crossIcon, onClick: clearFilters }, languageData.clearFilters))));
};
//# sourceMappingURL=FilterRow.js.map